import React, { Component } from 'react';

import Clock from './../../components/clock';
import ZmanTevilah from './../../components/zman-tevilah';
import RoomTiles from './../receptionist/RoomTiles';
import SignalR from './../../components/signalr';
import LanguageSelector from './../../components/language-selector';
import { getRooms, getCubicles } from './../../models/room';
import { getSections } from './../../models/section';
import { getReservations } from './../../models/reservation';
import NotificationSoundFile from './../../assets/sounds/notification.mp3';
import moment from 'moment';
import i18n from './../../i18n';
import { SettingsContext } from './../../components/context';

class AttendantMapView extends Component {
  static contextType = SettingsContext;

  constructor(props) {
    super(props);
    this.state = {
      isLoadedRooms: false,
      isLoadedCubicles: false,
      modal: false,
      error: null,
    };
     
    this.notificationSound = new Audio(NotificationSoundFile);
    this.playNotificationSound = this.playNotificationSound.bind(this);
  }

  componentDidMount() {
    this.retrieveRooms();
    this.retrieveSections();
    // Need setting for if have cubicles and waiting room
    this.retrieveReservations();
    if(this.props.siteSettings.useCubicles){
      this.retrieveCubicles();
    }
    this.setUpTick();
  }

  setUpTick() {
    this.intervalID = setInterval(() => this.setState({time: moment().format()}), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalID);
  }

  retrieveReservations() {
    getReservations()
      .then(
        result => {
          let reservations = result;

          this.setState({
            reservations: reservations,
            isLoadedReservations: true,
          });
        },
        error => {
          this.setState({
            isLoadedReservations: false,
            errorReservations: error
          });
        }
      );
  }

  retrieveRooms() {
    getRooms()
      .then(
        result => {
          let rooms = result;
          let groupedRooms = rooms.reduce(function (r, a) {
            r[a.effectiveStatus] = r[a.effectiveStatus] || [];
            r[a.effectiveStatus].push(a);
            return r;
          },Object.create(null));
          this.setState({
            isLoadedRooms: true,
            rooms: rooms,
            groupedRooms,
            error: null,
          });
        },
        error => {
          this.setState({
            isLoadedRooms: false,
            error
          });
        }
      );
  }

  retrieveCubicles() {
    getCubicles()
      .then(
        result => {
          this.setState({
            isLoadedCubicles: true,
            cubicles: result,
            error: null,
          });
        },
        error => {
          this.setState({
            isLoadedCubicles: true,
            error
          });
        }
      );
  }

  handleRoomUpdated(room) {
    const { rooms } = this.state;
    const index = rooms.findIndex(r => r.id === room.id);
    rooms[index] = room;
    this.setState({rooms});
  }

  retrieveSections() {
    getSections()
      .then(
        result => {
          this.setState({
            isLoadedSections: true,
            sections: result,
          });
        },
        error => {
          this.setState({
            isLoadedSections: false,
            error
          });
        }
      );
  }

  playNotificationSound(isReadyMikvah) {
    const {settings} = this.context;
    if((settings && settings.reservationsCheckingBeforeReadyForMikvah && settings.reservationsCheckingBeforeReadyForMikvah.value==="True")&&isReadyMikvah){
      return false;
    } else{
      this.notificationSound.play();
    }
  }

  render() {
    const RoomTilesCustom = this.props.roomTiles;
    const { rooms, isLoadedRooms, error, isLoadedSections, sections, reservations, isLoadedCubicles, cubicles, groupedRooms } = this.state;
    return (
      <div>
        <SignalR setReception={true} onRoomsUpdated={() => this.retrieveRooms()} onSectionsUpdated={() => this.retrieveSections()} onNewSupplyRequest={() => this.playNotificationSound()} onNewReadyForMikvah={() => this.playNotificationSound(true)} onNewReadyForChecking={() => this.playNotificationSound()}/>
        <div className={'container-page view-map view-attendant-map lang-' + i18n.language}>
          <div className="container-main">
            <header className="header">
              <div>
                <div className="header-left">
                  <ZmanTevilah />
                </div>
                <div className="header-right">
                  <Clock />
                  <Clock type="fullDate" />
                </div>
              </div>
            </header>
            <LanguageSelector />
            <div className="container-body">
              <SettingsContext.Consumer>
                {({settings}) =>
                  this.props.roomTiles?
                  <RoomTilesCustom attendantMapView={true} reservations={reservations} rooms={rooms} isLoadedRooms={isLoadedRooms} isLoadedCubicles={isLoadedCubicles} cubicles={cubicles} error={error} isLoadedSections={isLoadedSections} sections={sections} handleRoomUpdated={(r) => this.handleRoomUpdated(r)} time={this.state.time} settings={settings} groupedRooms={groupedRooms} />
                  :
                  <RoomTiles attendantMapView={true} reservations={reservations} rooms={rooms} isLoadedRooms={isLoadedRooms} isLoadedCubicles={isLoadedCubicles} cubicles={cubicles} error={error} isLoadedSections={isLoadedSections} sections={sections} handleRoomUpdated={(r) => this.handleRoomUpdated(r)} time={this.state.time} settings={settings} groupedRooms={groupedRooms} />
                }
              </SettingsContext.Consumer>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AttendantMapView;
